import { render, staticRenderFns } from "./ArchiveBookings.vue?vue&type=template&id=8dd47a36"
import script from "./ArchiveBookings.vue?vue&type=script&lang=js"
export * from "./ArchiveBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports